import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import invoiceReducer from './invoiceSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    invoices: invoiceReducer,  },
});

export default store;
